import React, {Fragment, useState} from "react";
import Selector from "../../../../../../components/selector";
import EnhancedModal from "../../../../../../components/enhanced-modal";
import {Button} from "antd";
import {MODAL_WIDTH_LG} from "../../../../../../styles/constants";
import InfiniteScrollTable from "../../../../../../components/infinite-scroll-table";
import {compose} from "redux";
import {translate} from "react-i18next";

const ModalSelector = ({form, fieldName, columns, data, modalTitle, disabled, t}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    return (
        <Fragment>
            <Selector
                value={!!form.getFieldValue(fieldName) ? form.getFieldValue(fieldName) : null}
                selectTitle={t('scenes.utilities.compareDsds.targetDsdSelector.selectButton.title')}
                resetTitle={t('scenes.utilities.compareDsds.targetDsdSelector.resetButton.title')}
                onSelect={() => setIsModalOpen(true)}
                onReset={() => form.setFieldsValue({[fieldName]: null})}
                disabled={disabled}
            />
            {
                !disabled && <EnhancedModal
                    visible={isModalOpen}
                    title={t(modalTitle)}
                    footer={<Button
                        onClick={() => setIsModalOpen(false)}>{t('commons.buttons.close.title')}</Button>}
                    onCancel={() => setIsModalOpen(false)}
                    width={MODAL_WIDTH_LG}
                >
                    <InfiniteScrollTable
                        data={data}
                        getRowKey={({name}) => name}
                        columns={columns}
                        onRowClick={({name}) => {
                            form.setFieldsValue({[fieldName]: name})
                            setIsModalOpen(false)
                        }}
                    />
                </EnhancedModal>
            }
        </Fragment>
    )
}

export default compose(
    translate()
)(ModalSelector);